import { render, staticRenderFns } from "./foodCoupon.vue?vue&type=template&id=2c67a9f2&scoped=true"
import script from "./foodCoupon.vue?vue&type=script&lang=js"
export * from "./foodCoupon.vue?vue&type=script&lang=js"
import style0 from "./foodCoupon.vue?vue&type=style&index=0&id=2c67a9f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c67a9f2",
  null
  
)

export default component.exports